<template>
    <div class="check-box">
        <van-nav-bar title="上课免打扰" fixed left-text="返回" :border="false" left-arrow @click-left="backPage" />
        <div class="check-date">
            <p class="title">免打扰时段</p>
            <div class="more-box">
                <div class="more-flex" @click="openPicker(true)">
                    <span class="more-span">开始时间</span>
                    <p class="more-surplus">{{data.startTime?data.startTime:'请设置'}}</p>
                    <div class="arrows"></div>
                </div>
                <div class="more-flex" @click="openPicker(false)">
                    <span class="more-span">结束时间</span>
                    <p class="more-surplus">{{data.endTime?data.endTime:'请设置'}}</p>
                    <div class="arrows"></div>
                </div>
                </div>
                <div class="more-box">
                <div class="more-flex" @click="toDateOption()">
                    <span class="more-span">重复</span>
                    <p class="more-surplus">{{data.day?data.day:'请设置'}}</p>
                    <div class="arrows"></div>
                </div>
            </div>
            <div class="btn-box">
                <van-button round type="info" @click="save" :class="[!true?'save-opcity':'']">保存</van-button>
                <p v-if="isUpdate" class="delete-time" @click="deleteTime">删除此时段</p>
            </div>
            <van-popup v-model="showPicker" round position="bottom" @close="onClose">
            <van-datetime-picker
                type="time"
                title="请选择时间"
                :value="currentDate"
                @input="onInput"
                @cancel="showPicker=false"
                @confirm="changeDatetime"
            />
            </van-popup>
            <van-dialog id="van-dialog" />
        </div>
    </div>
</template>

<script>
import bus from '@/utils/lib/bus'
export default {
    data() {
        return {
            checked:false,//开关状态
            showPicker:false,//时间控件
            isUpdate:false,//是不是修改
            currentDate: '12:00',
            data:{
                startTime:null,
                endTime:null,
                day:null
            },
            startOrEnd:false,
        };
    },

    created() {
        if(this.$store.state.checkdata){
            let data = JSON.parse(this.$store.state.checkdata);
            let arr = []
            data.dateList.forEach((item,index) => {
                if(item.isCheck){
                    arr.push(item.text)
                }
            });
            this.data.day = arr.join(',')
            this.data.startTime = data.option.startTime
            this.data.endTime = data.option.endTime
            this.data.index = data.option.index
            this.data.stealthStatus = data.option.stealthStatus
            this.isUpdate = data.option.isUpdate
            this.$store.commit('set_checkdata', null);
        }else if (this.$route.query.timeData) {
            let data = JSON.parse(this.$route.query.timeData);
            this.data = data
            this.isUpdate = data.bool
            // if(data.bool){
            //     this.data = data
            //     this.isUpdate = true
            // }else{
            //     this.isUpdate = false
            // }
        }
    },
    mounted(){
        // bus.$off("checkDisturb")
        // bus.$on('checkDisturb',res=>{
        //     console.log("触发了")
        //     let arr = []
        //     res.forEach((item,index) => {
        //         if(item.isCheck){
        //         arr.push(item.text)
        //         }
        //     });
        //     this.data.day = arr.join(',')
        //     console.log(this.data,33)
        // })
    },
    methods: {
        /**
        * 返回上一级
        */
        backPage() {
            this.$router.back(-1);
        },
        onClose(){
            this.showPicker=false
        },
        //选择日期
        onInput(event) {
        this.currentDate = event;
        },
        toDateOption(){
            // let data = {
            //     time:this.data,
            //     option:this.data.day
            // }
            this.data['isUpdate'] = this.isUpdate?this.isUpdate:false;
            this.$router.push({ name: 'dateOption',query: { data: this.data }});
        },
        openPicker(bool){
        this.startOrEnd = bool;
        this.showPicker = true
        },
        //选择时间
        changeDatetime(e){
        this.startOrEnd?this.data.startTime = e:this.data.endTime = e
        this.showPicker = false
        },
        CompareDate (t1,t2){
            var date = new Date();
            var a = t1.split(":");
            var b = t2.split(":");
            return date.setHours(a[0],a[1]) <= date.setHours(b[0],b[1]);
        },
        //保存
        save(){
            console.log(this.data,8888888)
        var date = new Date();
        var a = this.data.startTime?this.data.startTime.split(":"):['',''];
        var b = this.data.endTime?this.data.endTime.split(":"):['',''];
        if(!this.data.startTime){
            this.$toast("开始时间不能为空");
            return
        }
        if(!this.data.endTime){
            this.$toast("结束时间不能为空");
            return
        }
        if(date.setHours(a[0],a[1]) > date.setHours(b[0],b[1])){
            this.$toast("开始时间不能大于结束时间");
            return
        }
        if(date.setHours(a[0],a[1]) == date.setHours(b[0],b[1])){
            this.$toast("开始时间不能等于结束时间");
            return
        }
        if(!this.data.day || this.data.day==''){
            this.$toast("请选择重复时段");
            return
        }
        let arr = [];
        arr.push(
            {
            times:this.data.startTime+'-'+this.data.endTime,
            days:this.data.day
            }
        )
        let data = {
            ver:1,
            method:'sendAttendClassDoNotDisturb',
            stealthStatus:this.data.stealthStatus?'1':'0',
            type:this.isUpdate?'update':'add',
            index:this.isUpdate?this.data.index:'-1',
            paramArr:JSON.stringify(arr)
        }
        this.$http.get(this.$api.userInfo.POST_APPLET,data).then(res => {
            if (res.code === 0) {
                this.$toast({
                    message: "保存成功",
                    duration: 2000,
                    icon: require('@/assets/images/safety-fence/correct.png'),
                });
               this.$router.back(-1);
            } else {
                this.$toast({
                    message: res.msg,
                    duration: 2000,
                    icon: require('@/assets/images/safety-fence/wrong.png'),
                });
            }
        })
        },
        //删除此时段
        deleteTime(){
        this.$dialog.confirm({
            title: '提示',
            message: '是否删除该时段？',
        })
            .then(() => {
            let arr = [];
            arr.push(
                {
                times:this.data.startTime+'-'+this.data.endTime,
                days:this.data.day
                }
            )
            let data = {
                ver:1,
                method:'sendAttendClassDoNotDisturb',
                stealthStatus:this.data.stealthStatus?'1':'0',
                type:'delete',
                index:this.data.index,
                paramArr:JSON.stringify(arr)
            }
            this.$http.get(this.$api.userInfo.POST_APPLET,data).then(res => {
                if (res.code === 0) {
                    this.$toast("已删除");
                    this.$router.back(-1);
                } else {
                   this.$toast({
                        message: res.msg,
                        duration: 2000,
                        icon: require('@/assets/images/safety-fence/wrong.png'),
                    });
                }
            })
            })
            .catch(() => {
            // on cancel
            });
        }
    },
};
</script>

<style lang="scss" scoped>
.check-date{
  background: #f8f8f8;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  padding: 0 40px ;
}
.check-date .title{
  font-size: 30px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #666666;
  margin: 35px 0 35px 32px;
}
.more-box{
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #fff;
  border-radius: 20px;
  margin-top: 25px;
}
.more-flex{
  display: flex;
  align-items: center;
  width: 670px;
  height: 101px;
}
.more-span{
  font-size: 30px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 600;
  color: #111111;
  margin-left: 32px;
}
.more-surplus{
  text-align: right;
  flex: 1;
  font-size: 30px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #999999;
}
.arrows{
  width: 15px;
  height: 15px;
  transform:rotate(45deg);
  border-top: 3px solid #999;
  border-right: 3px solid #999;
  margin: 0 36px 0 20px;
}
.btn-box{
  z-index: 1;
  position: fixed;
  width: 100%;
  padding: 20px 0 50px;
  bottom: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #f8f8f8;
}
.btn-box .delete-time{
  margin-top: 48px;
  font-size: 28px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #FC4D56;
}
</style>
<style lang="scss">
.check-date .btn-box .van-button{
  margin: 0 auto;
  border: none;
  width: 586px;
  height: 98px;
  background: #01ADA9;
  color: #fff;
  border: 2px solid #01ADA9; 
}
.save-opcity .van-button{
  opacity: 0.3;
}
.check-box{
    .van-nav-bar{
        background-color: #F8F8F8;
        width: 100%;
    }
}
</style>